import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OnnaReportResponse} from '../../../../../models/oona-post';
import {ReportSectionEnum} from '../../../../../models/measure/report';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';
import {CommonConstant} from '../../../../app.constants';

@Component({
  selector: 'oona-report',
  templateUrl: './oona-report.component.html',
  styleUrls: ['./oona-report.component.scss']
})
export class OonaReportComponent implements OnInit, AfterViewInit {
  static COMPONENT_NAME = 'OonaReportComponent';
  static MAX_POST_PER_PAGE = 9;

  @Input() public data: OnnaReportResponse;
  // only use for PDF export. This indicate the index of current component
  @Input() pageIndex: number;
  @Input() numOfItemPerPage = CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
  @Output() changePage: EventEmitter<any> = new EventEmitter();
  currentPage = 1;

  constructor(private pdfService: PdfExportService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.data.data.length === 0) {
      this.pdfService.incrementNumberReportReady(`${OonaReportComponent.COMPONENT_NAME}${this.pageIndex}`);
      return;
    }

    this.pdfService.imagedLoadedTrigger.subscribe(data => {
      if (data.component === `${OonaReportComponent.COMPONENT_NAME}${this.pageIndex}` && data.currentCounter === this.data.data.length) {
        this.pdfService.incrementNumberReportReady(`${OonaReportComponent.COMPONENT_NAME}${this.pageIndex}`);
      }
    });
  }

  get maxPage() {
    if (!this.data || !this.data.totalCount) {
      return 0;
    }
    const totalFullPage = Math.floor(this.data.totalCount / this.numOfItemPerPage);
    const hasPartialPage = (this.data.totalCount % this.numOfItemPerPage) > 0;
    return hasPartialPage ? totalFullPage + 1 : totalFullPage;
  }

  onChangePage(evt) {
    this.changePage.emit({
      reportSection: ReportSectionEnum.OONA_REPORT,
      criteriaChange: {page_no: evt}
    });
    // deplay for rendering
    setTimeout(() => {
      this.currentPage = evt;
    }, 200);
  }

  get isExportingPdfReport() {
    return this.pdfService.exportingPdf;
  }

  get haveNoData() {
    return this.data && (!this.data.data || this.data.data.length === 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/oona-report/oona-report.component.ts